// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__18Ifi","title":"BackImages_title__2C9ah","images":"BackImages_images__22COj"};